// pages/Impersonate.jsx — page pont ouverte par le SuperAdmin dans un nouvel
// onglet après validation du code de support : récupère le token émis par
// POST /superadmin/users/:id/impersonate (passé en query string).
//
// Le token est vérifié explicitement ici (appel /auth/me) AVANT tout stockage
// dans localStorage et toute redirection vers /app.
//
// Important : cette vérification passe par un axios "brut", pas par
// l'instance partagée `api` (utils/api.js) — celle-ci a un intercepteur qui
// redirige *immédiatement* vers /login sur toute réponse 401, ce qui prenait
// de vitesse notre propre message d'erreur et donnait l'impression trompeuse
// qu'il fallait se reconnecter avec les identifiants de l'utilisateur.
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import BrandIcon from '../components/BrandIcon';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

export default function Impersonate() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setError("Lien invalide : aucun jeton de connexion fourni."); return; }

    axios.get(`${API_BASE}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => {
        localStorage.setItem('eg_token', token);
        localStorage.setItem('eg_impersonating', '1');
        window.location.replace('/app');
      })
      .catch((e) => {
        setError(
          e.response?.status === 401
            ? "Ce lien de connexion a expiré ou a déjà été utilisé. Demandez au support de générer une nouvelle session."
            : "Impossible de vérifier le lien de connexion (erreur serveur)."
        );
      });
  }, [searchParams]);

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'#0a0b0f', fontFamily:'Inter, sans-serif', padding:20 }}>
      <div style={{ width:380, maxWidth:'100%', textAlign:'center' }}>
        <div style={{ display:'flex', justifyContent:'center', marginBottom:16 }}><BrandIcon size={44}/></div>
        {error ? (
          <>
            <h1 style={{ color:'#fff', fontSize:18, fontWeight:700, margin:0 }}>Connexion impossible</h1>
            <p style={{ color:'#ff4d6d', fontSize:13, marginTop:12, lineHeight:1.5 }}>{error}</p>
          </>
        ) : (
          <>
            <span className="spinner" />
            <p style={{ color:'#888', fontSize:13, marginTop:16 }}>Connexion en cours…</p>
          </>
        )}
      </div>
    </div>
  );
}
